/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon24Solid = forwardRef('ShapeTriangleUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.31 4.432c-1.082-1.68-3.538-1.68-4.62 0L1.735 16.759C.556 18.59 1.869 21 4.046 21h15.907c2.178 0 3.492-2.41 2.31-4.24L14.312 4.431Z" })));
});
